import React, { Component } from 'react';
import {
  css
} from 'emotion';
import {
  blue
}
from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/colors";
import {
  gridGutter,
}
from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export default class RulesTable extends Component {
  render = () => {
    if (!this.props.rules) {
      return null;
    }
    return (
      <div>
        <div className="row">
          <div className="col-xs-16 col-md-16">
            <p className={css`margin: ${gridGutter}px 0`}>Veja aqui as regras e valores para remarcação e cancelamento aplicadas a sua passagem.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-16 col-md-16">
            <table className={`table ${css`text-align: left`}`}>
              <tbody>
                {this.props.rules.map((rule, key) => (
                  <tr key={key}>
                    <td className={css`color: ${blue}`}><strong>{rule.name}</strong></td>
                    <td>
                      <strong>Remarcação:</strong><br/>
                      { rule.changeText }<br/>
                    </td>
                    <td>
                      <strong>Cancelamento:</strong><br/>
                      {rule.cancelText}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}